<template>
  <div :id="id">
    <div class="cursor-pointer" @click="handleIconClick()">
      <aha-icon
        name="kebab-menu"
        width="18"
        height="18"
        viewBox="0 0 14 14"
      />
    </div>
    <aha-context-menu
      ref="context-menu"
      :target="id"
      :x="targetX"
      :y="targetY"
    >
      <slot name="context-menu-header">
        <aha-context-menu-header>
          {{ presentation.name }}
        </aha-context-menu-header>
      </slot>
      <slot name="context-menu-content">
        <aha-context-menu-item
          v-if="checkPermissionPresentationItem(permissions.PRESENT) && !isEnableAddinPowerpoint"
          @click="handleClickPresent()"
          class="context-menu--present font-bold"
        >
          <aha-icon
            name="play"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <span>{{ $i18nPresenter.t("Present") }}</span>
        </aha-context-menu-item>
        <aha-context-menu-item
          @click="handleClickToRename()"
          v-if="checkPermissionPresentationItem(permissions.RENAME_PRESENTATION)"
        >
          <aha-icon
            class="text-base-70"
            name="edit"
            viewBox="0 0 22 22"
            width="16"
            height="16"
          />
          <span>{{ $i18nPresenter.t("Rename") }}</span>
        </aha-context-menu-item>
        <aha-context-menu-item @click="handleClickInviteParticipants()">
          <aha-svg
            v-if="!isInvitingParticipant"
            class="text-base-70"
            name="share"
            width="20"
            height="20"
            viewBox="0 0 24 24"
          />
          <aha-spinner v-else />
          <span>{{ $i18nPresenter.t("Share") }}</span>
        </aha-context-menu-item>
        <aha-context-menu-item
          class="report-menu-item"
          @click="handleClickReport"
        >
          <aha-svg
            name="multiple-choice-w"
            class="text-base-70"
            width="16"
            height="16"
            view-box="0 0 30 30"
          />
          <span>{{ $i18nPresenter.t("Report") }}</span>
        </aha-context-menu-item>
        <div v-if="showSencondBorder()" class="my-1 border-b border-solid border-base-30" @click.stop />
        <aha-context-menu-item
          @click="handleResetResultsItemClick()"
          v-if="checkPermissionPresentationItem(permissions.CLEAR_RESULT)"
        >
          <aha-icon
            v-if="!isOpeningClearDataModal"
            class="text-base-70"
            name="reset"
          />
          <aha-spinner v-if="isOpeningClearDataModal" />
          <span>{{ $i18nPresenter.t("Reset results") }}</span>
        </aha-context-menu-item>
        <aha-context-menu-item
          @click="handleMoveToItemClick()"
          v-if="presentation.User.id === $store.state.currentUser.id"
          class="context-menu-item md:hidden lg:hidden xl:hidden p-0"
        >
          <aha-svg class="text-base-70" name="move" />
          <span>{{ $i18nPresenter.t("Move to") }}</span>
        </aha-context-menu-item>
        <aha-context-menu-item
          @click.stop="isDuplicatePresentationDisabled ? false : handleDuplicatePresentation()"
          :disabled="isDuplicatePresentationDisabled"
          v-tooltip="isDuplicatePresentationDisabled ? isDuplicatePresentationDisabledTooltip : null"
          v-if="checkPermissionPresentationItem(permissions.CREATE_PRESENTATION)"
        >
          <aha-icon
            name="duplicate"
            class="text-base-70"
            width="18"
            height="18"
            viewBox="0 0 20 20"
            v-if="!isDuplicatingPresentation"
          />
          <aha-spinner v-else />
          <span>{{ $i18nPresenter.t("Duplicate") }}</span>
        </aha-context-menu-item>
        <div class="block my-1 border-b border-solid border-base-30 md:hidden" @click.stop />
        <aha-context-menu-item
          class="flex md:hidden"
          @click="handleClickViewDetail"
        >
          <aha-svg
            name="info-circle"
            class="text-base-70"
            width="14"
            height="14"
            view-box="0 0 18 18"
          />
          <span>{{ $i18nPresenter.t("View Detail") }}</span>
        </aha-context-menu-item>

        <div
          v-if="showDeletePresentationItem || showLeavePresentationItem"
          class="my-1 border-b border-solid border-base-30"
          @click.stop
        />
        <aha-context-menu-item
          v-if="showDeletePresentationItem"
          @click="handleDeletePresnItemClick()"
          class="text-red-100"
        >
          <aha-svg name="delete" />
          <span v-if="canUseTrashBin">{{ $i18nPresenter.t("Move to trash") }}</span>
          <span v-if="!canUseTrashBin">{{ $i18nPresenter.t("Delete") }}</span>
        </aha-context-menu-item>
        <aha-context-menu-item
          v-if="showLeavePresentationItem"
          @click="handleLeavePresentationItemClick()"
          class="text-red-100"
        >
          <aha-svg name="logout" />
          <span>{{ $i18nPresenter.t("Leave") }}</span>
        </aha-context-menu-item>
      </slot>
    </aha-context-menu>

    <modal-clear-data
      :presentation="presentation"
      v-if="isShowingClearDataModal"
      @hide="handleHideClearDataModal()"
      :title="resetResultsHeading"
      :defaultModal="true"
    />

    <modal-delete-presentations
      :deleted-presentations="[presentation]"
      v-if="showingDelelePresentationsModal"
      @hide="handleHideDeletePresentations()"
    />

    <ModalLeavePresentations
      :leave-presentations="[presentation]"
      v-if="showingLeavePresentationsModal"
      @hide="handleHideLeavePresentations()"
    />
    <modal-move-presentations
      :selected-presentations="[presentation]"
      v-if="isShowingMovePresnModal"
      @hide="handleHideMovePresentation()"
    />

    <EditorShareV2Modal
      :presentation="presentation"
      v-if="isShowShareV2Popup"
      @hideModal="isInviteParticipantsModalShowing = false"
      source="presentations-list"
    ></EditorShareV2Modal>
    <CopyToWorkspaceModal
      v-if="isCopyToWorkspaceModalShowing && currentAccount.id"
      :presentation="presentation"
      @hide="isCopyToWorkspaceModalShowing = false"
    />
    <ShareToEditModal
      v-if="isShareToEditModalShowing && workingMode !== 'team'"
      :presentation="presentation"
      @hide="isShareToEditModalShowing = false"
    />
    <ShareToTeamForEditModal
      :presentation="presentation"
      v-if="isShareToEditModalShowing && workingMode === 'team'"
      :teamName="currentAccount.name"
      @hide="isShareToEditModalShowing = false"
    />
    <PresentationDetail
      v-if="isShowingPresentationDetail"
      :presentation="presentation"
      @hide="handleHideViewDetails"
    />
    <RenamePresentationModal
      v-if="isShowRenameModal"
      :presentation="presentation"
      @hide="isShowRenameModal = false"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

// utils
import utils from '@/util'

// constants
import constants from '@/constant'

// configs
import configs from '@/config'

// eventbus
import EventBus from '@/eventBus'

// modals
import ModalClearData from '../../modals/ClearData.vue'
import ModalDeletePresentations from '../../modals/DeletePresentations.vue'
import ModalLeavePresentations from '../../modals/LeavePresentations.vue'
import ModalMovePresentations from '../../modals/MovePresentations.vue'
import ShareToEditModal from '../../modals/ShareToEditModal.vue'
import ShareToTeamForEditModal from '../../modals/ShareToTeamForEdit.vue'
import CopyToWorkspaceModal from '../../modals/CopyToWorkspace.vue'
import RenamePresentationModal from '@/components-v2/modals/RenamePresentationModal.vue'
import PresentationDetail from './PresentationDetail.vue'
import mixpanelUtils from '@/utils/mixpanel.utils'
import EditorShareV2Modal from '@/components-v2/modals/EditorShareV2Modal.vue'

const { eventCategories } = constants
const { MAX_PRESENTATION_IN_FOLDER } = configs

export default {
  components: {
    EditorShareV2Modal,
    ModalClearData,
    ModalDeletePresentations,
    ModalMovePresentations,
    ShareToEditModal,
    ShareToTeamForEditModal,
    CopyToWorkspaceModal,
    ModalLeavePresentations,
    PresentationDetail,
    RenamePresentationModal,
  },
  props: {
    presentation: {
      type: Object,
      default: null,
    },
    id: {
      type: String,
      default() {
        return Math.random().toString().substring(7)
      },
    },
    rightClickEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isShowingClearDataModal: false,
      isDuplicatingPresentation: false,
      isInvitingParticipant: false,
      isOpeningClearDataModal: false,
      showingLeavePresentationsModal: false,
      showingDelelePresentationsModal: false,
      isShowingMovePresnModal: false,
      targetX: null,
      targetY: null,
      isShareToEditModalShowing: false,
      isCopyToWorkspaceModalShowing: false,
      isInviteParticipantsModalShowing: false,
      isShowingPresentationDetail: false,
      isShowRenameModal: false,
      text_Reset: this.$i18nPresenter.t('Reset'),
      permissions: constants.permissions,
    }
  },
  computed: {
    ...mapState({
      presentations: (state) => state.presentations,
      currentUser: (state) => state.currentUser,
      workingMode: (state) => state.workingMode,
      currentAccount: (state) => state.currentAccount,
      currentFolderDepth: (state) => state.currentFolderDepth,
      currentFolder: (state) => state.currentFolder,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
    }),
    ...mapGetters('featureToggles', ['canUseTrashBin']),
    isShowShareV2Popup() {
      return this.isInviteParticipantsModalShowing
    },
    resetResultsHeading() {
      return `${this.text_Reset} '${this.presentation.name}'?'`
    },
    isUserNotEditor() {
      return this.presentation.userId !== this.currentUser.id &&
        this.presentation.takenOverBy !== this.currentUser.id
    },
    isResetResultsButtonDisabled() {
      return !this.presentation.hasResults || this.presentation.participantsCount === 0 ||
        this.isUserNotEditor
    },
    showDeletePresentationItem() {
      // if (this.$route.name === 'ShareFolderDetail' || this.$route.name === 'SharedWithMe') {
      //   return this.presentation.User.id === this.$store.state.currentUser.id
      // }
      // const isPresentationBelongToAccountSpaceOfCurrentUser = this.presentation.accountId === this.currentUser.accountId
      // const isPresentationBelongToPersonalSpaceOfCurrentUser = this.presentation.userId === this.currentUser.id
      // const isCurrentUserOwnerOrAdminOfAccountSpace = this.currentUser.accountRole === constants.workspace.OWNER ||
      //   this.currentUser.accountRole === constants.workspace.ADMIN
      // if (isPresentationBelongToPersonalSpaceOfCurrentUser) {
      //   return true
      // }
      // if (isPresentationBelongToAccountSpaceOfCurrentUser || isCurrentUserOwnerOrAdminOfAccountSpace) {
      //   return true
      // }
      return this.checkPermissionPresentationItem(constants.permissions.DELETE_FOLDER)
    },
    showLeavePresentationItem() {
      if (this.$route.name === 'ShareFolderDetail' || this.$route.name === 'SharedWithMe') {
        return this.presentation.sharedPresentation && this.presentation.User.id !== this.$store.state.currentUser.id &&
          !this.presentation.isSharedAccount
      }
      return false
      // return this.presentation.User.id !== this.$store.state.currentUser.id && this.workingMode !== 'team'
    },
    isDuplicatePresentationDisabled() {
      return this.presentations && this.presentations.length === this.parseIntMaxPresentationInFolder
        && this.currentFolderDepth > 0
    },
    isDuplicatePresentationDisabledTooltip() {
      return `Maximum presentations reached (${this.parseIntMaxPresentationInFolder}/${this.parseIntMaxPresentationInFolder})`
    },
    parseIntMaxPresentationInFolder() {
      return parseInt(MAX_PRESENTATION_IN_FOLDER, 10)
    },
  },
  mounted() {
    if (this.rightClickEnabled) {
      EventBus.$on(`open-share-edit-modal-${this.presentation.id}`, () => {
        this.handleClickInviteParticipants()
      })
      EventBus.$on('open-kebab-presentation', ({ id, x, y }) => {
        if (id !== this.presentation.id) {
          return
        }

        this.targetX = x
        this.targetY = y
        this.handleIconClick(true)
      })
    }
  },
  destroyed() {
    EventBus.$off('open-kebab-presentation')
    EventBus.$off(`open-share-edit-modal-${this.presentation.id}`)
  },
  methods: {
    ...mapActions(['setPresentationsAction', 'setErrorOnInternalServerAction']),
    ...mapActions('presentationReport', ['selectPresentationAction', 'openReportPanelAction', 'subscribeReportAction']),
    ...mapActions('zoomApp', [
      'shareAppToParticipantsAction',
      'attachPresentationToZoomMeetingAction',
    ]),
    ...mapActions('trash', ['deletePresentationsAction']),
    handleIconClick(exact) {
      if (!exact) {
        this.targetX = null
        this.targetY = null
      }

      this.isShowingClearDataModal = false
      this.showingDelelePresentationsModal = false
      this.$refs['context-menu'].show()
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_LIST,
        'Presentation Kebab Menu > Open',
        null,
        null,
        {
          trigger: exact ? 'contextmenu' : 'click',
          presentationId: this.presentation.id,
          isTeamPresentations: this.$store.state.workingMode === constants.workspace.TEAM,
        },
      )
    },
    async handleResetResultsItemClick() {
      this.isOpeningClearDataModal = true
      const hasPerm = await this.$func.isCurrentEditorRealtime(this.presentation, this)
      this.isOpeningClearDataModal = false
      if (!hasPerm) return
      this.isShowingClearDataModal = true
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Clear result > Open modal')
    },
    async handleDeletePresnItemClick() {
      // if (this.canUseTrashBin && this.$refs.deletePresentationModal) {
      //   this.deletePresentationsAction([this.presentation.id])
      //   return
      // }
      this.showingDelelePresentationsModal = true
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Delete presentation > Open modal')
    },
    handleLeavePresentationItemClick() {
      this.showingLeavePresentationsModal = true
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Leave presentation > Open modal')
    },
    async handleHideClearDataModal() {
      this.isShowingClearDataModal = false
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Clear result > Close modal')
    },
    async handleHideDeletePresentations() {
      this.showingDelelePresentationsModal = false
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Delete presentation > Close modal')
    },
    handleHideLeavePresentations() {
      this.showingLeavePresentationsModal = false
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Leave presentation > Close modal')
    },
    handleHideMovePresentation() {
      this.isShowingMovePresnModal = false
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Move presentation > Close modal')
    },
    handleMoveToItemClick() {
      this.isShowingMovePresnModal = true
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Move presentation > Open modal')
    },
    handleClickShareToEdit() {
      this.isShareToEditModalShowing = true

      const teamId = this.$store.state.workingMode === constants.workspace.PERSONAL ?
        null : (
          this.$store.state.currentAccount.id
        )
      const presentationId = this.presentation.id
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST,
        'Presentation Kebab Menu > Open Invite to edit Dialog',
        '',
        '',
        {
          teamId,
          presentationId,
        })
    },
    handleClickViewDetail() {
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Open View Detail')
      this.isShowingPresentationDetail = true
      document.body.classList.add('no-scroll') // avoid background scrolling
    },
    handleClickReport() {
      this.$router.push({
        name: 'PresentationReport',
        params: { id: this.presentation.id },
      })
      utils.trackGA4AndMixpanel(eventCategories.PRESENTATION_REPORT, {
        eventAction: 'Presentation > Click view report',
        eventCategory: eventCategories.PRESENTATION_LIST,
        ...{
          presentationId: this.presentation.id,
        },
      })
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Open Report', this.presentation.id, null, 'Presentation List kebab menu')
    },
    handleHideViewDetails() {
      this.isShowingPresentationDetail = false
      document.body.classList.remove('no-scroll')
    },
    async handleClickInviteParticipants() {
      this.isInvitingParticipant = true
      const hasPerm = await this.$func.isCurrentEditorRealtime(this.presentation, this)
      this.isInvitingParticipant = false
      if (!hasPerm) return
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Open Share menu')
      this.isInviteParticipantsModalShowing = true
    },
    async handleDuplicatePresentation() {
      this.isDuplicatingPresentation = true
      // const isOwner = this.presentation.userId === this.currentUser.id
      try {
        // if (isOwner || this.$route.name === 'ShareFolderDetail') {
        //   await this.$http.post(configs.api.duplicatePresentation, {
        //     name: this.presentation.name,
        //     id: this.presentation.id,
        //     isFolderIdRemained: true,
        //   })
        // } else if (this.$route.name === 'TeamFolderDetail') {
        //   // duplicate inside folder team
        //   await this.$http.post(configs.api.copyPresentation, {
        //     id: this.presentation.shareCode,
        //     name: this.presentation.name,
        //     fromWorkspace: true,
        //     isFolderIdRemained: true,
        //   })
        // } else {
        //   // Copy, duplicate for sharewithme and team root
        //   await this.$http.post(configs.api.copyPresentation, {
        //     id: this.presentation.shareCode,
        //     name: this.presentation.name,
        //     fromWorkspace: (this.$route.name === 'Team'),
        //   })
        // }

        if (this.$route.name === 'SharedWithMe') {
          await this.$http.post(configs.api.copyPresentation, {
            id: this.presentation.shareCode,
            name: this.presentation.name,
          })
        } else {
          await this.$http.post(configs.api.duplicatePresentation, {
            name: this.presentation.name,
            id: this.presentation.id,
            isFolderIdRemained: true,
          })
        }

        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Create new presentation', 'Presentation kebab menu > Make a copy', this.presentation.id, {
          sourcePresentationId: this.presentation.id,
          ...mixpanelUtils.getPresentationContext(this.presentation),
        })
        utils.showToastSuccess(this.$i18nPresenter.t('Presentation duplicated.'))

        EventBus.$emit('reload-presentations-and-folders')
      } catch (error) {
        this.$refs['context-menu'].hide()
        this.setErrorOnInternalServerAction(`${this.$i18nPresenter.t('Cannot duplicate presentation:')} ${this.presentation.name}`)
        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation > Duplicate > Failed')
        this.isDuplicatingPresentation = false

        throw error
      }
    },
    handleClickCopyToWorkspace() {
      this.isCopyToWorkspaceModalShowing = true
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_LIST,
        'Presentation Kebab Menu > Open copy to anorther workspace modal',
        null,
        null,
        {
          presentationId: this.presentation.id,
          isTeamPresentations: this.$store.state.workingMode === constants.workspace.TEAM,
        },
      )
    },
    async handleClickPresent() {
      this.$router.push({
        name: 'PresentationDetail',
        params: {
          id: this.presentation.id,
        },
        query: {
          presenting: true,
        },
      })
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Present')
    },
    handleClickToRename() {
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation Kebab Menu > Rename > Open modal')
      this.isShowRenameModal = true
    },
    // isAllowToCopyAcrossWorkspace() {
    //   if (this.$route.name === 'ShareFolderDetail' || this.$route.name === 'SharedWithMe') return false
    //   if (this.currentUser && !this.currentUser.accountId) return false
    //   if (this.currentUser.permissions &&
    //     // eslint-disable-next-line max-len
    //     !this.currentUser.permissions.includes(constants.permissions.COPY_PRESENTATIONS_ACROSS_WORKSPACES)) {
    //     return false
    //   }
    //   return true
    // },
    checkPermissionPresentationItem(permission) {
      // const isTeamPresentations =
      //   this.presentation.accountId && this.presentation.accountId == this.currentUser.accountId

      // if (isTeamPresentations) {
      //   return this.currentUser.permissions.includes(permission)
      // }

      // if (this.currentFolder) {
      return (this.currentFolder && this.currentFolder.ownerId === this.currentUser.id) ||
        (this.presentation.permissions &&
          this.presentation.permissions.includes(permission))
      // }
      // return true
    },
    showSencondBorder() {
      return this.checkPermissionPresentationItem(constants.permissions.CLEAR_RESULT)
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1100px) {
  .report-menu-item {
    display: none;
  }
}
.context-menu--present {
  @apply text-primary-90;
}
</style>
